<template>
  <!-- 主页 -->
  <div class="home" :class="linkUrl !== '' ? 'height0' : ''">
    <!-- bannar+主体 -->
    <div class="bannar">
      <!-- <img src="../../public/img/link/bannar.jpg" /> -->
      <div class="bigtitle">
        <p class="bannerdes1">友情链接</p>
        <p class="bannerdes2">friendship link</p>
        <div class="bannaerline"></div>
        <p class="bannerdes3">点击链接，更加深入的了解我们吧</p>
      </div>
    </div>
    <div class="model model1">
      <div class="imgBox">
        <img class="imgBox_pic" src="../../public/img/download.png" alt="" />
        <a class="clickArea" href="http://www.azureflying.com/apk_wt.apk"> </a>
      </div>
    </div>
    <!-- 1.友情链接 -->
    <div class="model model1">
      <Minetitle2 :title1="titleArr[0].title1" :title2="titleArr[0].title2" />
      <div class="model1shadow"></div>
      <div class="model1_arr clearfix" style="overflow: auto">
        <div class="model1_arr1 modelAnt">
          <p class="model1_title">蔚复来商学院</p>
          <div class="model1_line"></div>
          <p class="model1_des" style="margin-bottom: 90px">
            WEUFULAI BUSINESS SCHOOL
          </p>
          <div class="btn_lookdetail" @click="link(1)">查看详情</div>
        </div>
        <div class="model1_arr2 modelAnt">
          <p class="model1_title">智慧环保平台</p>
          <div class="model1_line"></div>
          <p class="model1_des">SMART ENVIRONMENTAL PROTECTION</p>
          <div class="btn_lookdetail" @click="link(2)">查看详情</div>
        </div>
        <div class="model1_arr3 modelAnt">
          <p class="model1_title">易腐垃圾处理子系统</p>
          <div class="model1_line"></div>
          <div class="model1_des">DISPOSAL OF PERISHABLE WASTE</div>
          <div class="btn_lookdetail" @click="link(3)">查看详情</div>
        </div>
      </div>
    </div>
    <!-- 2.合作单位 -->
    <div class="model model2">
      <Minetitle2 :title1="titleArr[1].title1" :title2="titleArr[1].title2" />
      <div class="model2_unitArr clearfix">
        <img
          :src="picUrl + item.pic"
          alt=""
          :key="item.id"
          v-for="item in unitArr"
        />
      </div>
    </div>
    <div class="finalLink" v-show="this.linkUrl !== ''">
      <img class="linkbg" :src="linkPic" alt="" />
      <img
        class="linkClose"
        v-show="linkUrl == 1"
        src="../../public/img/link/close1.png"
        alt=""
        @click="closeLink"
      />
      <img
        class="linkClose"
        v-show="linkUrl == 2"
        src="../../public/img/link/close2.png"
        alt=""
        @click="closeLink"
      />
    </div>
  </div>
</template>

<script>
import Minetitle2 from "../components/minetitle2.vue";
import { picUrl } from "@/config/env";
import { postPv } from "@/api/postPv";

// @ is an alias to /src
export default {
  inject: ["reload"],
  name: "minelink",
  data() {
    return {
      // 图片链接

      picUrl: "",
      linkPic: "",
      linkUrl: "", //友情链接 //
      //题目组
      titleArr: [
        { id: 1, title1: "友情链接", title2: "friendship link" },
        { id: 2, title1: "合作单位", title2: "Cooperation unit" },
      ],
      unitArr: [
        { id: 1, pic: "/img/link/logo1.jpg" },
        { id: 2, pic: "/img/link/logo2.jpg" },
        { id: 3, pic: "/img/link/logo3.jpg" },
        { id: 4, pic: "/img/link/logo4.jpg" },
        { id: 5, pic: "/img/link/logo5.jpg" },
        { id: 6, pic: "/img/link/logo6.jpg" },
        { id: 7, pic: "/img/link/logo7.jpg" },
        { id: 8, pic: "/img/link/logo8.jpg" },
        { id: 9, pic: "/img/link/logo9.png" },
      ],
    };
  },
  watch: {
    // 监控滚动距离和vw
  },
  methods: {
    tableclick() {
      //切换标题栏跳转
    },
    link(index) {
      let url;
      if (index == 1) {
        this.$message({
          message: "暂未开放,敬请期待",
        });
      } else if (index == 2) {
        this.linkUrl = 1;
        this.linkPic = this.picUrl + "/img/link/bg1.jpg";
      } else {
        this.linkUrl = 2;
        this.linkPic = this.picUrl + "/img/link/bg2.jpg";
      }
    },
    closeLink() {
      this.linkUrl = "";
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.picUrl = picUrl;
      postPv("https://www.azureflying.com/api/blade-website/analytics/access")
        .then((res) => {})
        .catch((err) => {});
      //发送pv
    });
  },
  components: { Minetitle2, picUrl },
};
</script>
<style scoped>
.home {
  width: 100%;
  overflow-x: hidden;
  padding-top: 80px;
}
.bannar {
  width: 100%;
  height: 673px;
  position: relative;
  background: url("../../public/img/link/bannar.jpg") no-repeat;
  background-size: cover;
}
.bigtitle {
  width: 100%;
  position: absolute;
  left: 0px;
  top: 137px;
  text-align: center;
}
.bannerdes1 {
  font-size: 76px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  line-height: 72px;
  margin-bottom: 32px;
  letter-spacing: 10px;
}
.bannerdes2 {
  font-size: 40px;
  line-height: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  margin-bottom: 60px;
  letter-spacing: 3px;
}
.bannaerline {
  width: 68px;
  height: 6px;
  background: #cccccc;
  margin: 0 auto 41px;
}
.bannerdes3 {
  width: 100%;
  height: auto;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #fff;
  opacity: 0.7;
  letter-spacing: 3px;
}

/* 公司简介 */
.model1shadow {
  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: -20%;
  z-index: 1;
  background: #f7f7f7;
}
.model {
  width: 80%;
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
}
.model1 {
  padding-top: 80px;
  padding-bottom: 100px;
}
/* 友情链接 */
.model1_arr {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 2;
}
.model1_arr1,
.model1_arr2,
.model1_arr3 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.model1_arr1 {
  width: 567px;
  height: 825px;
  background: url("../../public/img/link/ex0.png") no-repeat;
  float: left;
}
.model1_arr2 {
  width: 758px;
  height: 393px;
  background: url("../../public/img/link/ex1.png") no-repeat;
  float: right;
  margin-bottom: 38px;
}
.model1_arr3 {
  width: 758px;
  height: 394px;
  background: url("../../public/img/link/ex2.png") no-repeat;
  float: right;
}
.model1_title {
  font-size: 60px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 25px;
  height: 80px;
}
.model1_line {
  width: 54px;
  height: 3px;
  background: #ffffff;
  opacity: 0.5;
  margin-bottom: 30px;
}
.model1_des {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #ffffff;
  opacity: 0.6;
  margin-bottom: 30px;
}
.btn_lookdetail {
  width: 162px;
  height: 59px;
  line-height: 59px;
  text-align: center;
  background: #dddddd;
  border-radius: 8px;
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
}
.model2 {
  padding: 68px 0 0 50px;
}
.model2_unitArr {
  width: 100%;
  height: auto;
}
.model2_unitArr img {
  width: 295px;
  height: 150px;
  float: left;
  margin-right: 40px;
  margin-bottom: 40px;
}
.model2_unitArr img:nth-child(4n) {
  margin-right: 0;
}
.model2_unitArr img:hover {
  animation: iconRate 4s;
}
@keyframes iconRate {
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(360deg);
  }
  100% {
    transform: rotateY(0deg);
  }
}

/* 最后 */
.finalLink {
  width: 100vw;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  overflow: hidden;
}
.linkbg {
  width: 100%;
}
.linkClose {
  width: 69px;
  height: 69px;
  position: absolute;
  right: 30px;
  top: 30px;
}
.height0 {
  height: 0;
}
.modelAnt {
  /* overflow: hidden; */
  border-radius: 8px;
  box-shadow: 2px 2px 8px 2px rgba(0, 0, 0, 0.5);
}

.modelAnt:hover .model1_title {
  font-size: 62px;
  transition: font-size 0.1s linear;
}
.modelAnt:hover .btn_lookdetail {
  background: #589ef8;
  color: white;
  animation: background 0.1s linear;
}
.imgBox {
  width: 100%;
  position: relative;
  z-index: 99;
}
.imgBox_pic {
  width: 100%;
  border: 1px solid;
  margin-top: 20px;
  border-radius: 3px;
  box-shadow: 2px 2px 8px 2px rgba(0, 0, 0, 0.2);
}
.clickArea {
  position: absolute;
  left: 353px;
  bottom: 133px;
  z-index: 2;
  width: 136px;
  height: 45px;
}
</style>
